import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ApiService } from '../service/api.service';
import { NotificationService } from '../service/notification.service';
import { Router } from '@angular/router';
import * as XLSX from 'xlsx';


@Component({
  selector: 'app-apolist',
  templateUrl: './apolist.component.html',
  styleUrls: ['./apolist.component.css']
})
export class ApolistComponent implements OnInit {
  filterForm: FormGroup;
  selectedItem: any = null;
  executionForm: FormGroup;
  filterResult: any[] = [];     // Main loaded data
  filteredData: any[] = [];     // Search filtered data
  paginatedData: any[] = [];    // Displayed page data


  circleList: any[]=[];
  divisionlist: any[]=[];
  rangelist: any[]=[];
  schemeList: any[]=[];
  subSchemeList: any=[];
  componentList: any[]=[];
  financialYears: any[]=[];

  searchText = '';

  currentPage = 1;
  pageSize = 10;
  totalItems: number = 0;
  totalPages: number = 0;
  pagesArray: number[] = [];
  userid: any;
  circleDisabled: boolean;
  divisionDisabled: boolean;
  rangeDisabled: boolean;

 

  
  constructor(
    private readonly apiService: ApiService,
    private readonly fb: FormBuilder,
    private readonly notifyService:NotificationService,
    private readonly router:Router
  ) {
    this.filterForm = this.fb.group({
      circle: [''],
      division: [''],
      range:[''],
      activity: [''],
      scheme: [''],
      subscheme: [''],
      component: [''],
      year: [''],
      fromDate: [''],
      toDate: ['']
    });
    this.executionForm = this.fb.group({
      kmlFile: [null],
      beforeImage: [null],
      afterImage: [null],
      planFile: [null],
      dprFile: [null],
      tenderFile: [null],
      workOrderFile: [null],
      completionFile: [null]
    });
    const userdata=sessionStorage.getItem('user');
    if(userdata!=null){
      const user=JSON.parse(userdata);
      this.userid=user.userid;
      this.getAllCircle();
      this.isCircleDivisionRangeDisabled(user);
    }else{
      this.router.navigate(['/']);
    }
  }

  ngOnInit(): void {
    this.generateFinancialYears();
    this.getAllSchemeDD();
    this.loadFilterResult();
  }
  generateFinancialYears() {
    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();
    const currentMonth = currentDate.getMonth() + 1;
  
    // If current month >= April, financial year is currentYear - nextYear
    const startYear = (currentMonth >= 4) ? currentYear : currentYear - 1;
  
    const years:any = [];
    for (let i = 0; i < 5; i++) {
      const fromYear = startYear - i;
      const toYear = fromYear + 1;
      years.push({
        display: `${fromYear}-${toYear.toString().slice(-2)}`,  // display as 2025-26
        value: `${fromYear}-${toYear}`                           // value as 2025-2026
      });
    }
  
    this.financialYears = years.toSorted((a, b) => b.value.localeCompare(a.value));
  
    // Set default selected year in form
    this.filterForm.patchValue({ year: this.financialYears[0].value });
  }
  getAllCircle() {
    this.apiService.request('GET', 'api/v1/masters/getAllCircle').subscribe((data: any) => {
     if(data)
     {
       this.circleList=data;
     }
   });
 }
 getAllDivisionByCircleId(circle:any){
  //console.log(circle)
   if(circle!="0"){
    //console.log("in Circle",circle)
     this.apiService.request('GET', 'api/v1/masters/getAllDivisionByCircleId?id='+circle).subscribe((data: any) => {
     if(data)
     {
      //console.log("in getAllDivisionByCircleId",circle)
      //console.log("data",data)
       this.divisionlist=data;
     }
   });
 }
 }
 getAllRangeByDivId(division:any) {
  //console.log(division)
 if(division!="0"){
  //console.log("in Division",division)
 this.apiService.request('GET', 'api/v1/masters/getAllRangeByDivid?id='+division).subscribe((data: any) => {
    if(data)
    {
      this.rangelist=data;
      //console.log(this.rangelist);
    }
  });
}
}
isCircleDivisionRangeDisabled(user:any) {
  
  if (user != null) {
     const roleId = user.roleId;
    if (roleId == 1 || roleId == 3) {
      this.filterForm.patchValue({
        circle: [''],
        division: [''],
        range:['']
      });
       // Disable the fields
       this.filterForm.get('circle')?.enable();
       this.filterForm.get('division')?.enable();
       this.filterForm.get('range')?.enable();
    }
    else if (roleId == 6 || roleId == 10) {
      this.filterForm.patchValue({
        circle: [user.circleId],
      });
     
      this.getAllDivisionByCircleId(user.circleId);
        // Disable the fields
        this.filterForm.get('circle')?.disable();
    }
    else if (roleId == 2 || roleId == 11) {
      this.filterForm.patchValue({
        circle: [user.circleId],
        division: [user.divisionId]
      });
      this.getAllDivisionByCircleId(user.circleId);
      this.getAllRangeByDivId(user.divisionId);
         // Disable the fields
         this.filterForm.get('circle')?.disable();
         this.filterForm.get('division')?.disable();
    }
    else if (roleId == 4 || roleId == 5 || roleId == 12) {
      this.filterForm.patchValue({
        circle: [user.circleId],
        division: [user.divisionId],
        range: [user.rangeId]
    });

      this.getAllDivisionByCircleId(user.circleId);
      this.getAllRangeByDivId(user.divisionId);

      // Disable the fields
      this.filterForm.get('circle')?.disable();
      this.filterForm.get('division')?.disable();
      this.filterForm.get('range')?.disable();
    }
  }
}


  getAllSchemeDD() {
    this.apiService.request('GET', 'api/v1/APO/getAllSchemeDD').subscribe((data: any) => {
    if (data) {
      this.schemeList = data;
      }
    });
  }
  
 getAllSubSchemeDD(schemeId:any) {
     this.apiService.request('GET', `api/v1/APO/getAllSubSchemeDD?schemeId=${Number(schemeId)}`).subscribe(
     (data: any) => {
       if (data && Array.isArray(data)) {
         this.subSchemeList = data;  
       } 
     },
     (error) => {  
       this.notifyService.showError('Failed to load scheme', 'Error');
     });
  }
  getAllComponentDDByScheme(event: any) {
  let schemeId=event.target.value;
  this.apiService.request('GET', `api/v1/APO/getAllComponentDDByScheme?schemeId=${schemeId}`).subscribe(
    (data: any) => {
    
      if (data && Array.isArray(data)) {
        this.componentList = data;
      } 
    },
    (error) => {
    
    }
  );
  }


  loadFilterResult(): void {
     const formValues = this.filterForm.getRawValue();
     //console.log(formValues )
    const params: string[] = [];

    if (formValues.year) params.push(`financialYear=${formValues.year}`);
    if (formValues.circle) params.push(`circleId=${formValues.circle}`);
    if (formValues.division) params.push(`divId=${formValues.division}`);
    if (formValues.range) params.push(`rangeId=${formValues.range}`);
    if (formValues.scheme) params.push(`schemeId=${formValues.scheme}`);
     if (formValues.subscheme) params.push(`subSchemeId=${formValues.subscheme}`);
    if (formValues.component) params.push(`componentId=${formValues.component}`);
    if (formValues.fromDate) params.push(`startDate=${formValues.fromDate}`);
    if (formValues.toDate) params.push(`endDate=${formValues.toDate}`);

    // Optional: Add pagination default
    params.push(`page=0`);
    params.push(`size=10`);
  
    const queryString = params.join('&');
  
    this.apiService.request('GET', `api/v1/APO/getAPOList?${queryString}`).subscribe({
      next: (response: any) => {
        if (response.status === 1) {
          //console.log(response);
          // response.sort((a,b)=>{
          //   return a.creationDate-b.creationDate
          // })
          this.filterResult = response.data.data || [];
          this.totalItems = response.data.totalItems || 0;
          this.totalPages = response.data.totalPages || 1;
          this.currentPage = 1;
          this.filteredData = []; // Reset any old search
          this.setupPagination();
        } else {
          this.notifyService.showError("Failed", "Error");
        }
      },
      error: (error) => console.error('Error fetching filter options:', error)
    });
  }
  applyFilter(): void{
    this.loadFilterResult();
  }
  resetFilters(): void{
    this.divisionlist=[];
    this.componentList=[];
    this.filterForm = this.fb.group({
      circle: [''],
      division: [''],
      activity: [''],
      scheme: [''],
      component: [''],
      year: [''],
      fromDate: [''],
      toDate: ['']
    });
    this.filterForm.patchValue({ year: this.financialYears[0].value });
    this.searchText = '';
    this.loadFilterResult();
  }
//Search Input 
filterTable() {
  const search = this.searchText.toLowerCase();
  if (!search) {
    this.filteredData = [];
  } else {
    this.filteredData = this.filterResult.filter(item =>
      Object.values(item).some(
        (val: any) => val && val.toString().toLowerCase().includes(search)
      )
    );
  }
  this.currentPage = 1;
  this.setupPagination();
}
setupPagination() {
  const dataSource = this.filteredData.length > 0 ? this.filteredData : this.filterResult;
  this.totalItems = dataSource.length;
  this.totalPages = Math.ceil(this.totalItems / this.pageSize);
  this.pagesArray = Array.from({ length: this.totalPages }, (_, i) => i + 1);

  const start = (this.currentPage - 1) * this.pageSize;
  const end = start + this.pageSize;
  this.paginatedData = dataSource.slice(start, end);
  //console.log(this.paginatedData)
}
downloadApoListAsExcel(){
   // Prepare the data for export (using tableData as the "List of Records")
      const exportData = this.paginatedData.map(item => ({
        SlNo:item.slNo,
        CircleName: item.circleName || 'N/A',
        DivisionName: item.divName || 'N/A',
        RangeName: item.rangeName || 'N/A',
        MajorScheme: item.schemeName || 'N/A',
        Scheme: item.subSchemeName || 'N/A',
         ComponentName: item.componentName || 'N/A',
        ReportedBy: item.createdBy || 'N/A',
        creationDate: item.creationDate  || 'N/A'
      }));

      // Create a worksheet from the data
      const worksheet = XLSX.utils.json_to_sheet(exportData);
  
      // Create a workbook and append the worksheet
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, 'APO List');
  
      // Generate Excel file and trigger download
      XLSX.writeFile(workbook, `APO_List.xlsx`);
}
  changePage(page: number) {
    if (page >= 1 && page <= this.totalPages) {
      this.currentPage = page;
      this.setupPagination();
    }
  }
  

  viewForm(form: any): void {
   //console.log(form);
   // const params = `componentId=${form.componentId}&formId=${form.formId}`;
    this.router.navigate([`/apo-report/${form.componentId}/${form.formId}`], {
      queryParams: { mode: 'view' }
    });
    // this.apiService.request('GET', `api/v1/APO/ViewAllReportFormDetails?${params}`).subscribe({
    //   next: (response: any) => {
    //     //console.log(response);
    //     if (response && response.length > 0) {
    //       const apoRequest = response[0]; // Select first item (adjust if needed)
    //       //console.log('View API Response:', apoRequest);
    //       try {
    //         this.router.navigate(['/apo-report'], {
    //           state: {
    //             apoRequest,
    //             isReadOnly: true
    //           }
    //         });
    //         //console.log('Navigated to /aporeport with state:', { apoRequest, isReadOnly: true });
    //       } catch (error) {
    //         console.error('Error navigating to Aporeport:', error);
    //         this.notifyService.showError('Failed to navigate to form', 'Error');
    //       }
    //     } else {
    //       this.notifyService.showError('No form details found', 'Error');
    //     }
    //   },
    //   error: (error) => {
    //     console.error('Error fetching form details:', error);
    //     this.notifyService.showError('Error fetching form details', 'Error');
    //   }
    // });
  }

  //************************************** */
  openExecutionModal(item: any): void {
    this.selectedItem = item;
    this.executionForm.reset();
  }
  onClickExecution(item:any){
     this.router.navigate([`/apo-apoexecution`])
  }
  onFileChange(event: Event, controlName: string): void {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      this.executionForm.get(controlName)?.setValue(input.files[0]);
      //console.log(`File selected for ${controlName}:`, input.files[0].name);
    }
  }
}
